<template lang="html">
  <div class="lowerthird">
    <div :class="text_container_style_name">
      <h1>{{ name }}</h1>
      <h2 v-if="title.length > 0">{{ title }}</h2>
      <div class="background" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Lowerthird",
  props: {
    name: {
      type: String,
      default: () => ""
    },
    title: {
      type: String,
      default: () => ""
    },
    controlsAutoHide: {
      type: Boolean,
      default: () => false
    }
  },
  computed:{
    text_container_style_name(){
      if(this.controlsAutoHide){
        return "text_container text_container_overlaid"
      }else{
        return "text_container"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lowerthird{
  position: absolute;
  font-family: Arial, Helvetica, Sans-Serif;
  color: white;
  width: 100%;
  height: 100%;
  //background-color: pink;
  // Make lowerthird text unselectable.
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  .text_container{
    position: absolute;
    bottom: 0px;
    left: 6%;
    width: auto;
    //background-color: rgba(0, 0, 0, 0.3);
    //background-image: linear-gradient(rgba(0, 0, 0, 0.0),
    //                                  rgba(0, 0, 0, 0.2),
    //                                  rgba(0, 0, 0, 0.3),
    //                                  rgba(0, 0, 0, 0.4),
    //                                  rgba(0, 0, 0, 0.3),
    //                                  rgba(0, 0, 0, 0.2),
    //                                  rgba(0, 0, 0, 0.0)
    //                                  ) !important;
    font-size: 1em;
    -webkit-font-smoothing: antialiased;
    color: white;
    line-height: 1em;
    text-shadow: 2px 2px 3px #000;
    h1, h2{
      position: relative;
      left: 8%;
      z-index: 1;
    }
    .background{
      position: absolute;
      z-index: 0;
      top: 0;
      left: 3%;
      width: 110%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
      //background-color: pink;
      -webkit-filter: blur(15px);
      -moz-filter: blur(15px);
      -o-filter: blur(15px);
      -ms-filter: blur(15px);
      filter: blur(15px);
    }
  }
  .text_container_overlaid{
    bottom: 50px !important;
  }
}
</style>
